import React from 'react';
import i18next from 'i18next';

import './NotFound.scss';
import { Icon } from 'semantic-ui-react';

const NotFound = () => {
    return (
        <div className="pi not-found">
            <Icon name="cogs" color="black" />
            {i18next.t('general.pageNotFound')}
        </div>
    );
};

export default NotFound;
